import italy from '../img/italy.png';

export const DEMO_PRODUCT_ID = 'demo';

export const isDemoProduct = (productId) => productId === DEMO_PRODUCT_ID;

export const DEMO_COURSES = [
  {
    name: 'Курс італійської мови XL',
    nomenclature_id: 0,
    product_id: DEMO_PRODUCT_ID,
    qty: 10,
    total: '0.00',
    image: italy,
    status: 1,
    type: 'Груповий',
    cancellation_lesson_date: null,
    direction_name: 'Курс італійської мови',
    program_name: 'Італійська мова A1',
    level_name: 'A1',
    lessons_total: 40,
    lessons_passed: 16,
    lessons_left: 24,
    is_demo: true,
  },
];

export const DEMO_ACCOUNTS = [
  {
    id: 'demo-actual',
    document_name: 'S-09102026-1',
    document_url: '',
    created_at: '09.10.2026 04:00',
    payment_date: null,
    show_button_pay: true,
    qty: null,
    price: null,
    total_price: null,
    image: italy,
    nomenclature_name: 'Курс італійської мови XL',
    checkbox_url: null,
    show_document_url: false,
    valid_seconds: 0,
    payment_url: '',
  },
  ...['20.10.2026 18:47', '05.09.2026 13:55', '12.08.2026 10:12'].map((date, idx) => ({
    id: `demo-paid-${idx}`,
    document_name: `S-0${idx + 1}082026-${idx + 1}`,
    document_url: '',
    created_at: date,
    payment_date: date,
    show_button_pay: false,
    qty: 8,
    price: '240.00',
    total_price: '1920.00',
    image: italy,
    nomenclature_name: 'Курс італійської мови XL',
    checkbox_url: null,
    show_document_url: false,
  })),
];

export const DEMO_INVOICE = {
  id: 'demo-actual',
  document_number: 'S-09102026-1',
  document_url: '',
  created_at: '09.10.2026 04:00:17',
  entity_type: 'student',
  tariff_id: 0,
  nomenclature_name: 'Курс італійської мови XL',
  image: italy,
  payment_methods: [],
  counteragent_full_name: '',
  customer_counteragent_full_name: 'Тестовий Учень',
};

export const DEMO_TARIFFS = [
  { id: 1, name: 'Базовий', price: 470, hours: 8, show_hours: 8, bonus_hours: 0, is_special: 0, total_price: 3760 },
  { id: 2, name: 'Оптимальний', price: 470, hours: 16, show_hours: 16, bonus_hours: 0, is_special: 0, total_price: 7520 },
  { id: 3, name: 'До кінця курсу', price: 470, hours: 24, show_hours: 24, bonus_hours: 0, is_special: 0, total_price: 11280 },
];

export const DEMO_FULL_COURSE = { hours: 24, price: 470, total_price: 11280 };
